import { NgModule } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from './application/core/core.module';
import { SharedModule } from './shared/modules/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotfoundComponent } from './application/auth/components/notfound/notfound.component';
import { AccessComponent } from './application/auth/components/access/access.component';
import { ErrorComponent } from './application/auth/components/error/error.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PrivacyPolicyComponent } from './application/privacy-policy/privacy-policy.component';
import { ProgressBarModule } from 'primeng/progressbar';
export function tokenGetter() {
    return localStorage.getItem("idToken");
}

@NgModule({
    declarations: [
        AppComponent,
        NotfoundComponent,
        AccessComponent,
        ErrorComponent,
        PrivacyPolicyComponent,
    ],
    imports: [
        CoreModule,
        SharedModule,
        BrowserModule,
        AppRoutingModule,
        JwtModule.forRoot({
            config: {tokenGetter: tokenGetter}
        }),
        BrowserAnimationsModule,
        ProgressBarModule
    ],
    providers: [
        MessageService,
        ConfirmationService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }